import { FC } from "react";
import { inject, observer } from "mobx-react";
import { CommonModal } from "./CommonModal";
import PrintAdd from "components/modal/PrintAddModal";
import PrintAddSelect from "components/modal/PrintAddSelectModal";
import DeliveryConnectBusiness from "components/modal/DeliveryConnectBusinessModal";
import DeliveryConnectPosPick from "components/modal/DeliveryConnectPosPickModal";

const MODAL_COMPONENTS: Record<string, FC<any>> = {
  common: CommonModal,
  printAdd: PrintAdd,
  printAddSelect: PrintAddSelect,
  DeliveryConnectBusiness: DeliveryConnectBusiness,
  DeliveryConnectPosPick: DeliveryConnectPosPick,
};
const GlobalModalManager = ({ rootStore }: any) => {
  const { modalStore } = rootStore;
  const { activeModals } = modalStore;

  if (activeModals.length === 0) {
    return null;
  }
  return (
    <>
      {activeModals.map((modal: any, index: any) => {
        const { modalType, props } = modal;
        const ModalComponent = MODAL_COMPONENTS[modalType];

        const handleClose = () => modalStore.closeModal(modalType);

        return (
          <div key={modalType} style={{ zIndex: 100 + index, position: "relative" }}>
            <ModalComponent {...props} onClose={handleClose} />
          </div>
        );
      })}
    </>
  );
};

export default inject("rootStore")(observer(GlobalModalManager));
